<div class="tab-content" id="myTabContent">
  <div class="tab-pane fade show active" id="strategies-tab-pane" role="tabpanel" aria-labelledby="strategies-tab"
    tabindex="0">
    <ul class="nav nav-tabs bottab mt-2" id="myTab" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="activeBot-tab" type="button" data-bs-toggle="tab"
          (click)="selectTab('activeBot', 'bot')" data-bs-target="#activeBot" role="tab" aria-controls="activeBot"
          [attr.aria-selected]="selectedTab === 'activeBot'" [ngClass]="{ active: selectedTab === 'activeBot' }">
          Spot Bots ({{ activeBotCount }})
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="stopedBot-tab" type="button" data-bs-toggle="tab"
          (click)="selectTab('stopedBot', 'bot')" data-bs-target="#stopedBot" role="tab" aria-controls="stopedBot"
          [attr.aria-selected]="selectedTab === 'stopedBot'" [ngClass]="{ active: selectedTab === 'stopedBot' }">
          Bot History
        </button>
      </li>
      <!--  <form [formGroup]="searchForm" (ngSubmit)="onSearch()">
              <div style="margin-left: 10%;" class="row mb-3">
                <div class="col-md-4">
                  <input type="date" id="fromDate" formControlName="fromDate" placeholder="From Date" class="form-control" />
                </div>
                <div class="col-md-4">
                  <input type="date" id="toDate" formControlName="toDate" placeholder="To Date" class="form-control" />
                </div>
                <div class="col-md-4 d-flex align-items-end">
                  <button type="submit" class="btn btn-primary w-100">Search</button>
                  <button type="button" class="btn btn-secondary ms-2" (click)="resetFilter()">Reset</button>
                </div>
              </div>
            </form>
            <div style="margin-left:10%;">
              <button class="btn btn-success ms-2" (click)="downloadExcel()">Export</button>
          </div> -->
      <!-- <div style="margin-left:10%;">
                <button class="btn btn-primary ms-2" (click)="routeToDownload()">View All History</button>
            </div> -->
    </ul>

    <!-- Bot mode -->
    <div class="tab-content" id="myTabContent">
      <div class="tab-pane fade" [ngClass]="{
          show: selectedTab === 'activeBot',
          active: selectedTab === 'activeBot'
        }" id="activeBot" role="tabpanel" aria-labelledby="activeBot-tab">
        <div class="bot-history-filter">
          <!-- <p>Sum, Current value $ {{toFixed(totCurrent,2)}}</p> -->
        </div>
        <!-- open bot -->
        <div class="table-responsive">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Pair/Bot Type</th>
                <th>PNL In %</th>
                <th>PNL</th>
                <th>TXNS/Time</th>
                <th>Investment</th>
                <th *ngIf="environment.production == false">Action</th>
              </tr>
            </thead>
            <tbody *ngIf="activeBotCount > 0; else noActiveBot">
              <tr *ngFor="let item of activeBotData" (click)="selectBot(item)" style="cursor: pointer">
                <td>
                  {{ item.pairName }}
                  <span class="botType">GRID</span>
                  <!-- <span class="botAction">Long</span> -->
                </td>
                <!-- //redText -->
                <td class="{{ item.pl > 0 ? 'greenTxt' : 'redText' }}">
                  {{ toFixed(item.pl, 2) }}%
                  <!-- <span class="valueInPrice">{{item.pnlval}} USDT</span> -->
                </td>
                <td class="{{ item.pnlval > 0 ? 'greenTxt' : 'redText' }}">
                  {{ item.pnlval }} USDT
                </td>
                <td>{{ item.txnDate }}</td>
                <td>{{truncateDecimals(item?.totalInvestment?? item.investment,4) }}</td>
                <th>
                  <span class="botAction" (click)="onModelOpen(item)" data-bs-toggle="modal"
                    data-bs-target="#ohis_modal">View</span>
                </th>
              </tr>
            </tbody>
          </table>
          <div class="tab-pane">
            <nav class="primary_pagination" *ngIf="filter.totalPages > 1">
              <ul class="pagination">
                <li class="page-item" [ngClass]="{ disabled: filter.page == 1 }">
                  <span class="page-link cursor-pointer" aria-label="Previous" (click)="previousPage('bot')">
                    <span aria-hidden="true">&laquo;</span>
                  </span>
                </li>
                <li class="page-item" *ngFor="let item of getDisplayedPages">
                  <a class="page-link" [ngClass]="{ active: item == filter.page }" href="javascript:void(0)"
                    (click)="goToSelectedPage(item, 'bot')">{{ item }}</a>
                </li>
                <li class="page-item" [ngClass]="{ disabled: filter.totalPages == filter.page }">
                  <span class="page-link cursor-pointer" (click)="nextPage('bot')" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                  </span>
                </li>
              </ul>
            </nav>
          </div>
          <ng-template #noActiveBot>
            <tbody>
              <tr>
                <td colspan="9" style="border-color: transparent">
                  <div class="text-center mt-4 mb-4" *ngIf="auth.signedIn; else login">
                    <img src="assets/images/no_records_found.png" alt="Notification" class="img-fluid mb-2" />
                    <p>No Records Found!</p>
                  </div>
                  <ng-template #login>
                    <div class="text-center mt-4 mb-4">
                      <!-- <p>
                                              <a class="blue_txt no-underline" href="signin">Login</a> or <a class="blue_txt"
                                                  href="signup" class="blue_txt no-underline">Register</a> Now to trade
                                          </p> -->
                      <img src="assets/images/no_records_found.png" alt="Notification" class="img-fluid mb-2" />
                      <p>
                        <a class="blue_txt no-underline" href="signin">Login</a>
                        or
                        <a class="blue_txt" href="signup" class="blue_txt no-underline">Register</a>
                        Now to trade
                      </p>
                    </div>
                  </ng-template>
                </td>
              </tr>
            </tbody>
          </ng-template>
        </div>
      </div>
      <div class="tab-pane fade" [ngClass]="{
          show: selectedTab === 'stopedBot',
          active: selectedTab === 'stopedBot'
        }" id="stopedBot" role="tabpanel" aria-labelledby="stopedBot-tab">
        <!-- <div class="noActiveBots">
          <img src="assets/images/noactivebots.svg" class="img-fluid" alt="icon" />
          <p>You don’t have active bots</p>
          <button class="btn startButton">Start NewBot</button>
        </div> -->
        <div class="bot-history-filter">
          <div class="bh-filter-left">
            <!-- <p>Sum, Current value $ {{toFixed(sumProfitHis?.curVal,2)}}</p>
                        <p>
                            Sum, bot profit $ {{sumProfitHis?.sumpnlval}}
                            <span *ngIf="sumProfitHis.sumpnlval < 0" class="redText">{{sumProfitHis?.pnlVal}}%</span>
                            <span *ngIf="sumProfitHis.sumpnlval > 0" class="greenText">{{sumProfitHis?.pnlVal}}%</span>
                        </p>
                        <p>Sum, Investment $ {{sumProfitHis?.inv}}</p> -->
          </div>
          <!-- <div class="bh-filter-right">
                      <mat-form-field appearance="fill">
                          <input matInput [matDatepicker]="picker" />
                          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                      <button class="continue">
                          <img src="../../../assets/images/date_picker.png" alt="date" title="date" />
                      </button>
                      <button class="startButton">Download CSV</button>
                  </div> -->
        </div>
        <div class="table-responsive">
          <!-- closed bot -->
          <table class="table table-bordered">
            <thead>
              <tr>
                <!-- <th>Exchange</th> -->
                <th>Pair/Bot Type</th>
                <th>Fee (USDT)</th>
                <th>PNL In %</th>
                <th>PNL</th>
                <th>TXNS/Time</th>
                <th>Investment</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody *ngIf="botHistory.length > 0; else noBotClosed">
              <tr *ngFor="let item of botHistory" (click)="selectBot(item)" style="cursor: pointer">
                <!-- <td>
                                  <img src="assets/images/binance.svg" alt="Binance" title="Binance" />
                                  Binance
                              </td> -->
                <td>
                  {{ item.pairName }}
                  <span class="botType">GRID</span>
                  <!-- <span class="botAction">Long</span> -->
                </td>
                <td>{{ toFixedDown(item.fee, 8) }}</td>
                <!-- //redText -->
                <td class="{{ parseFloat(item.pl) > 0 ? 'greenTxt' : 'redText' }}">
                  {{ item.pl }}%
                  <!-- <span class="valueInPrice">{{item.pnlval}}{{item.secondCurrency}}</span> -->
                </td>
                <td class="{{
                    parseFloat(item.pnlval) > 0 ? 'greenTxt' : 'redText'
                  }}">
                  {{ item.pnlval }}
                  <span class="valueInPrice">{{ item.secondCurrency }}</span>
                </td>
                <td>{{ item.creAt }}</td>
                <td>{{ truncateDecimals(item?.totalInvestment?? item.investment,4) }}</td>
                <td>
                  <span class="greenTxt">Closed</span> {{ item.closeDate }}
                </td>
                <td>
                  <span class="botAction" (click)="onModelOpen(item)" data-bs-toggle="modal"
                    data-bs-target="#ohis_modal">View</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="tab-pane">
            <nav class="primary_pagination" *ngIf="filter.totalPages > 1">
              <ul class="pagination">
                <li class="page-item" [ngClass]="{ disabled: filter.page == 1 }">
                  <span class="page-link cursor-pointer" aria-label="Previous" (click)="previousPage('bot')">
                    <span aria-hidden="true">&laquo;</span>
                  </span>
                </li>
                <li class="page-item" *ngFor="let item of getDisplayedPages">
                  <a class="page-link" [ngClass]="{ active: item == filter.page }" href="javascript:void(0)"
                    (click)="goToSelectedPage(item, 'bot')">{{ item }}</a>
                </li>
                <li class="page-item" [ngClass]="{ disabled: filter.totalPages == filter.page }">
                  <span class="page-link cursor-pointer" (click)="nextPage('bot')" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                  </span>
                </li>
              </ul>
            </nav>
          </div>
          <ng-template #noBotClosed>
            <tbody>
              <tr>
                <td colspan="9" style="border-color: transparent">
                  <div class="text-center mt-4 mb-4" *ngIf="auth.signedIn; else login">
                    <img src="assets/images/no_records_found.png" alt="Notification" class="img-fluid mb-2" />
                    <p>No Records Found!</p>
                  </div>
                  <ng-template #login>
                    <div class="text-center mt-4 mb-4">
                      <!-- <p>
                                              <a class="blue_txt no-underline" href="signin">Login</a> or <a class="blue_txt"
                                                  href="signup" class="blue_txt no-underline">Register</a> Now to trade
                                          </p> -->
                      <img src="assets/images/no_records_found.png" alt="Notification" class="img-fluid mb-2" />
                      <p>
                        <a class="blue_txt no-underline" href="signin">Login</a>
                        or
                        <a class="blue_txt" href="signup" class="blue_txt no-underline">Register</a>
                        Now to trade
                      </p>
                    </div>
                  </ng-template>
                </td>
              </tr>
            </tbody>
          </ng-template>
        </div>
      </div>
    </div>

    <!-- Order history Modal -->
    <div class="modal fade primary_modal detail_model modal-xl" id="ohis_modal" tabindex="-1"
      aria-labelledby="ohis_modalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="ohis_modalLabel">
              Bot Orders History
            </h1>
            <div class="d-flex align-items-start">
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                (click)="onModelClose()"></button>
            </div>
          </div>
          <ul class="nav nav-tabs bottab mt-2" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="positionHistory-tab" type="button" data-bs-toggle="tab"
                data-bs-target="#positionHistory" role="tab" aria-controls="positionHistory"
                [attr.aria-selected]="selectedOrderTab === 'positionHistory'"
                [ngClass]="{ active: selectedOrderTab === 'positionHistory' }"
                (click)="selectTab('positionHistory', 'order')">
                Position History
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="closedOrder-tab" type="button" data-bs-toggle="tab"
                data-bs-target="#closedOrder" role="tab" aria-controls="closedOrder"
                [attr.aria-selected]="selectedTab === 'closedOrder'"
                [ngClass]="{ active: selectedOrderTab === 'closedOrder' }" (click)="selectTab('closedOrder', 'order')">
                Closed Orders
              </button>
            </li>
            <li *ngIf="openModelBotDetails &&
                openModelBotDetails.status == 'running'
              " class="nav-item" role="presentation">
              <button class="nav-link" id="openOrder-tab" type="button" data-bs-toggle="tab" data-bs-target="#openOrder"
                role="tab" aria-controls="openOrder" [attr.aria-selected]="selectedOrderTab === 'openOrder'"
                [ngClass]="{ active: selectedOrderTab === 'openOrder' }" (click)="selectTab('openOrder', 'order')">
                Open orders
              </button>
            </li>
          </ul>
          <div class="modal-body" style="max-height: 600px; overflow-y: auto">
            <!-- Position details in model -->
            <!-- <div class="d-flex flex-column flex-md-row justify-content-end align-items-end mb-3 gap-3">
              <div class="inputgrp_box">
                <div class="input-group">
                  <label class="grey">Investment</label
                  ><input
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    name=""
                    type="text"
                    class="form-control ng-pristine ng-valid ng-touched mb-0"
                  />
                </div>
              </div>
              <div class="inputgrp_box ">
                <div class="input-group">
                  <label class="grey">Total Profit</label
                  ><input
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    name=""
                    type="text"
                    class="form-control ng-pristine ng-valid ng-touched mb-0"
                  />
                </div>
              </div>
            </div> -->
            <div class="tab-content mt-3" id="myTabContent">
              <div class="tab-pane fade" [ngClass]="{
                  show: selectedOrderTab === 'positionHistory',
                  active: selectedOrderTab === 'positionHistory'
                }" id="positionHistory" role="tabpanel" aria-labelledby="positionHistory-tab">
                <div class="table-responsive">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th colspan="2">No</th>
                        <th>Date & Time</th>
                        <th>Side</th>
                        <th>Price</th>
                        <th>Amount</th>
                        <th>Total ({{ pairData.secondCurrencySymbol }})</th>
                        <th>Status</th>
                        <th>Fee</th>
                        <th *ngIf="openModelBotDetails && openModelBotDetails.status != 'running'">Profit</th>
                      </tr>
                    </thead>

                    <tbody *ngIf="botPositionHistory.length > 0; else noOpenPosData">
                      <ng-container *ngFor="let group of botPositionHistory">
                        <!-- Group Header -->
                        <!-- <tr>
                                                    <td colspan="9">
                                                        <div
                                                            class="group-header d-flex justify-content-between align-items-center p-2">
                                                            <div class="group-id  fw-bold">#{{ group.postRound }}</div>
                                                            <div class="profit fw-bold"
                                                                [ngClass]="{ 'text-success': group.profit >= 0, 'text-danger': group.profit < 0 }">
                                                                {{ group.profit }}
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr> -->

                        <!-- Sell Row -->
                        <tr *ngIf="group.sellOrderId">
                          <td colspan="2">
                            <div class="group-id fw-bold">
                              #{{ group.postRound }}
                            </div>
                          </td>
                          <td>
                            {{ dateTimeFormat(group.sellOrderId.createdAt) }}
                          </td>
                          <td><span class="text-danger">Sell</span></td>
                          <td>
                            {{
                            toFixedDown(
                            group.sellOrderId.status === "completed"
                            ? group.sellOrderId.avgPrice
                            : group.sellOrderId.price,
                            group.sellOrderId.secondFloatDigit
                            )
                            }}
                          </td>
                          <td>
                            {{
                            toFixedDown(
                            group.sellOrderId.status === "completed"
                            ? group.sellOrderId.fillQuantity
                            : group.sellOrderId.quantity,
                            group.sellOrderId.firstFloatDigit
                            )
                            }}
                          </td>
                          <td>
                            {{
                            group.sellOrderId.status === "completed"
                            ? toFixedDown(
                            group.sellOrderId.fillOrderValue,
                            group.sellOrderId.secondFloatDigit
                            )
                            : "-"
                            }}
                          </td>
                          <td [ngClass]="
                              group.sellOrderId.status === 'completed'
                                ? 'green_txt'
                                : 'red_txt'
                            ">
                            {{ firstCapital(group.sellOrderId.status) }}
                          </td>
                          <td>
                            {{
                            group.sellOrderId.status === "completed"
                            ? toFixedDown(group.sellOrderId.fee, 8)
                            : "-"
                            }}
                          </td>
                          <td colspan="2" *ngIf="openModelBotDetails && openModelBotDetails.status != 'running'">
                            <div class="profit fw-bold" [ngClass]="{
                                'text-success': group.profit >= 0,
                                'text-danger': group.profit < 0
                              }">
                              {{ toFixedDown(group.profit, 8) }}
                            </div>
                          </td>
                        </tr>

                        <!-- Sell Missing Message -->
                        <tr *ngIf="isEmpty(group.sellOrderId)">
                          <td colspan="2">
                            <div class="group-id fw-bold">
                              #{{ group.postRound }}
                            </div>
                          </td>
                          <td *ngIf="
                              group.buyOrderId &&
                              group.buyOrderId.status != 'cancelled'
                            ">
                            Your sell order is still waiting to be completed.
                          </td>
                        </tr>
                        <!-- Buy Row -->
                        <tr *ngIf="group.buyOrderId">
                          <td colspan="2"></td>
                          <td>
                            {{ dateTimeFormat(group.buyOrderId.createdAt) }}
                          </td>
                          <td><span class="text-success">Buy</span></td>
                          <td>
                            {{
                            toFixedDown(
                            group.buyOrderId.status === "completed"
                            ? group.buyOrderId.avgPrice
                            : group.buyOrderId.price,
                            group.buyOrderId.secondFloatDigit
                            )
                            }}
                          </td>
                          <td>
                            {{
                            toFixedDown(
                            group.buyOrderId.status === "completed"
                            ? group.buyOrderId.fillQuantity
                            : group.buyOrderId.quantity,
                            group.buyOrderId.firstFloatDigit
                            )
                            }}
                          </td>

                          <td>
                            {{
                            group.buyOrderId.status === "completed"
                            ? toFixedDown(
                            group.buyOrderId.fillOrderValue,
                            group.buyOrderId.secondFloatDigit
                            )
                            : "-"
                            }}
                          </td>
                          <td [ngClass]="
                              group.buyOrderId.status === 'completed'
                                ? 'green_txt'
                                : 'red_txt'
                            ">
                            {{ firstCapital(group.buyOrderId.status) }}
                          </td>
                          <td>
                            {{
                            group.buyOrderId.status === "completed"
                            ? toFixedDown(group.buyOrderId.fee, 8)
                            : "-"
                            }}
                          </td>
                        </tr>
                        <tr *ngIf="isEmpty(group.buyOrderId)">
                          <td colspan="2">
                            <div class="group-id fw-bold">
                              #{{ group.postRound }}
                            </div>
                          </td>
                          <td *ngIf="
                              group.sellOrderId &&
                              group.sellOrderId.status != 'cancelled'
                            ">
                            Your buy order is still waiting to be completed..
                          </td>
                        </tr>
                        <hr style="
                            border: 0;
                            height: 1px;
                            background: transparent;
                            margin: 1rem 0;
                          " />
                      </ng-container>
                    </tbody>
                  </table>
                  <div class="tab-pane">
                    <nav class="primary_pagination" *ngIf="orderFilter.totalPages > 1">
                      <ul class="pagination">
                        <li class="page-item" [ngClass]="{ disabled: orderFilter.page == 1 }">
                          <span class="page-link cursor-pointer" aria-label="Previous" (click)="previousPage('order')">
                            <span aria-hidden="true">&laquo;</span>
                          </span>
                        </li>
                        <li class="page-item" *ngFor="let item of getDisplayedOrderPages">
                          <a class="page-link" [ngClass]="{ active: item == orderFilter.page }"
                            href="javascript:void(0)" (click)="goToSelectedPage(item, 'order')">{{ item }}</a>
                        </li>
                        <li class="page-item" [ngClass]="{
                            disabled: orderFilter.totalPages == orderFilter.page
                          }">
                          <span class="page-link cursor-pointer" (click)="nextPage('order')" aria-label="Next">
                            <span aria-hidden="true">&raquo;</span>
                          </span>
                        </li>
                      </ul>
                    </nav>
                  </div>
                  <ng-template #noOpenPosData>
                    <tbody>
                      <tr>
                        <td colspan="9" style="border-color: transparent">
                          <div class="text-center mt-4 mb-4" *ngIf="auth.signedIn; else login">
                            <img src="assets/images/no_records_found.png" alt="Notification" class="img-fluid mb-2" />
                            <p>No Records Found!</p>
                          </div>
                          <ng-template #login>
                            <div class="text-center mt-4 mb-4">
                              <!-- <p>
                                                          <a class="blue_txt no-underline" href="signin">Login</a> or <a class="blue_txt"
                                                              href="signup" class="blue_txt no-underline">Register</a> Now to trade
                                                      </p> -->
                              <img src="assets/images/no_records_found.png" alt="Notification" class="img-fluid mb-2" />
                              <p>
                                <a class="blue_txt no-underline" href="signin">Login</a>
                                or
                                <a class="blue_txt" href="signup" class="blue_txt no-underline">Register</a>
                                Now to trade
                              </p>
                            </div>
                          </ng-template>
                        </td>
                      </tr>
                    </tbody>
                  </ng-template>
                </div>
              </div>

              <div class="tab-pane fade" [ngClass]="{
                  show: selectedOrderTab === 'closedOrder',
                  active: selectedOrderTab === 'closedOrder'
                }" id="closedOrder" role="tabpanel" aria-labelledby="closedOrder-tab">
                <div class="table-responsive">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Date & Time Time</th>
                        <th>Pair</th>
                        <th>Side</th>
                        <th>Price</th>
                        <th>Amount</th>
                        <th>Total (USDT)</th>
                        <th>Fee</th>
                        <th>Status</th>

                        <!-- <th>Profit (USDT)</th> -->
                      </tr>
                    </thead>
                    <tbody *ngIf="orderList.length > 0; else noClosedOrder">
                      <tr *ngFor="let row of orderList">
                        <td>{{ dateTimeFormat(row.createdAt) }}</td>
                        <td>{{ row.pairName }}</td>
                        <td *ngIf="row.side == 'sell'">
                          <span class="red_txt">{{
                            firstCapital(row.side)
                            }}</span>
                        </td>
                        <td *ngIf="row.side == 'buy'">
                          <span class="green_txt">{{
                            firstCapital(row.side)
                            }}</span>
                        </td>
                        <td>
                          {{ toFixedDown(row.avgPrice, row.secondFloatDigit) }}
                        </td>
                        <td>
                          {{
                          toFixedDown(row.fillQuantity, row.firstFloatDigit)
                          }}
                        </td>
                        <td>
                          {{
                          toFixed(row.fillOrderValue, row.secondFloatDigit)
                          }}
                        </td>
                        <td>{{ toFixed(row.fee, 8) }}</td>
                        <td [ngClass]="
                            row.status === 'completed' ? 'green_txt' : 'red_txt'
                          ">
                          {{ firstCapital(row.status) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="tab-pane">
                    <nav class="primary_pagination" *ngIf="orderFilter.totalPages > 1">
                      <ul class="pagination">
                        <li class="page-item" [ngClass]="{ disabled: orderFilter.page == 1 }">
                          <span class="page-link cursor-pointer" aria-label="Previous" (click)="previousPage('order')">
                            <span aria-hidden="true">&laquo;</span>
                          </span>
                        </li>
                        <li class="page-item" *ngFor="let item of getDisplayedOrderPages">
                          <a class="page-link" [ngClass]="{ active: item == orderFilter.page }"
                            href="javascript:void(0)" (click)="goToSelectedPage(item, 'order')">{{ item }}</a>
                        </li>
                        <li class="page-item" [ngClass]="{
                            disabled: orderFilter.totalPages == orderFilter.page
                          }">
                          <span class="page-link cursor-pointer" (click)="nextPage('order')" aria-label="Next">
                            <span aria-hidden="true">&raquo;</span>
                          </span>
                        </li>
                      </ul>
                    </nav>
                  </div>
                  <ng-template #noClosedOrder>
                    <tbody>
                      <tr>
                        <td colspan="9" style="border-color: transparent">
                          <div class="text-center mt-4 mb-4" *ngIf="auth.signedIn; else login">
                            <img src="assets/images/no_records_found.png" alt="Notification" class="img-fluid mb-2" />
                            <p>No Records Found!</p>
                          </div>
                          <ng-template #login>
                            <div class="text-center mt-4 mb-4">
                              <!-- <p>
                                                          <a class="blue_txt no-underline" href="signin">Login</a> or <a class="blue_txt"
                                                              href="signup" class="blue_txt no-underline">Register</a> Now to trade
                                                      </p> -->
                              <img src="assets/images/no_records_found.png" alt="Notification" class="img-fluid mb-2" />
                              <p>
                                <a class="blue_txt no-underline" href="signin">Login</a>
                                or
                                <a class="blue_txt" href="signup" class="blue_txt no-underline">Register</a>
                                Now to trade
                              </p>
                            </div>
                          </ng-template>
                        </td>
                      </tr>
                    </tbody>
                  </ng-template>
                </div>
                <!-- <div class="bh-filter-right">
                          <button class="startButton mt-3">Download CSV</button>
                        </div> -->
              </div>

              <!-- open order details -->
              <div class="tab-pane fade" [ngClass]="{
                  show: selectedOrderTab === 'openOrder',
                  active: selectedOrderTab === 'openOrder'
                }" id="openOrder" role="tabpanel" aria-labelledby="openOrder-tab">
                <div class="table-responsive">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Date & Time Time</th>
                        <th>Pair</th>
                        <th>Side</th>
                        <th>Price</th>
                        <th>Amount</th>
                        <th>Total ({{ pairData.secondCurrencySymbol }})</th>
                        <th>Order Status</th>
                      </tr>
                    </thead>
                    <tbody *ngIf="openOrderList.length > 0; else noOpenOrderData">
                      <tr *ngFor="let row of openOrderList">
                        <td>{{ dateTimeFormat(row.createdAt) }}</td>
                        <td>{{ row.pairName }}</td>
                        <td *ngIf="row.side === 'buy'">
                          <span class="green_txt">{{
                            firstCapital(row.side)
                            }}</span>
                        </td>
                        <td *ngIf="row.side === 'sell'">
                          <span class="red_txt">{{
                            firstCapital(row.side)
                            }}</span>
                        </td>
                        <td>
                          {{ toFixedDown(row.price, row.secondFloatDigit) }}
                        </td>
                        <td>
                          {{ toFixedDown(row.quantity, row.firstFloatDigit) }}
                        </td>
                        <td>
                          {{
                          toFixedDown(
                          toFixedDown(row.price, row.secondFloatDigit) *
                          toFixedDown(row.quantity, row.firstFloatDigit),
                          row.firstFloatDigit + row.secondFloatDigit
                          )
                          }}
                        </td>
                        <td *ngIf="row.status == 'Cancelled'">
                          Manual Cancelled from exchange
                        </td>
                        <td *ngIf="row.status != 'Cancelled'" [ngClass]="
                            row.status === 'completed' ? 'green_txt' : 'red_txt'
                          ">
                          {{ firstCapital(row.status) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div class="tab-pane">
                    <nav class="primary_pagination" *ngIf="orderFilter.totalPages > 1">
                      <ul class="pagination">
                        <li class="page-item" [ngClass]="{ disabled: orderFilter.page == 1 }">
                          <span class="page-link cursor-pointer" aria-label="Previous" (click)="previousPage('order')">
                            <span aria-hidden="true">&laquo;</span>
                          </span>
                        </li>
                        <li class="page-item" *ngFor="let item of getDisplayedOrderPages">
                          <a class="page-link" [ngClass]="{ active: item == orderFilter.page }"
                            href="javascript:void(0)" (click)="goToSelectedPage(item, 'order')">{{ item }}</a>
                        </li>
                        <li class="page-item" [ngClass]="{
                            disabled: orderFilter.totalPages == orderFilter.page
                          }">
                          <span class="page-link cursor-pointer" (click)="nextPage('order')" aria-label="Next">
                            <span aria-hidden="true">&raquo;</span>
                          </span>
                        </li>
                      </ul>
                    </nav>
                  </div>
                  <ng-template #noOpenOrderData>
                    <tbody>
                      <tr>
                        <td colspan="9" style="border-color: transparent">
                          <div class="text-center mt-4 mb-4" *ngIf="auth.signedIn; else login">
                            <img src="assets/images/no_records_found.png" alt="Notification" class="img-fluid mb-2" />
                            <p>No Records Found!</p>
                          </div>
                          <ng-template #login>
                            <div class="text-center mt-4 mb-4">
                              <!-- <p>
                                                          <a class="blue_txt no-underline" href="signin">Login</a> or <a class="blue_txt"
                                                              href="signup" class="blue_txt no-underline">Register</a> Now to trade
                                                      </p> -->
                              <img src="assets/images/no_records_found.png" alt="Notification" class="img-fluid mb-2" />
                              <p>
                                <a class="blue_txt no-underline" href="signin">Login</a>
                                or
                                <a class="blue_txt" href="signup" class="blue_txt no-underline">Register</a>
                                Now to trade
                              </p>
                            </div>
                          </ng-template>
                        </td>
                      </tr>
                    </tbody>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
